import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type FieldTab = 'damage' | 'roads' | 'tasks' | 'zones' | 'supplies' | 'forms' | 'team';
type DrawerState = 'closed' | 'half' | 'full';
type QuickCreateMode = 'damage' | 'road' | null;
type DrawingMode = 'road_closure' | 'task' | null;

interface FieldState {
  isFieldMode: boolean;
  drawerState: DrawerState;
  drawerTab: FieldTab;
  quickCreateMode: QuickCreateMode;
  drawingMode: DrawingMode;

  // Breadcrumb tracking settings
  autoTrackBreadcrumbs: boolean;

  // Actions
  setFieldMode: (on: boolean) => void;
  setDrawerState: (state: DrawerState) => void;
  setDrawerTab: (tab: FieldTab) => void;
  toggleDrawer: () => void;
  setQuickCreateMode: (mode: QuickCreateMode) => void;
  setDrawingMode: (mode: DrawingMode) => void;
  setAutoTrackBreadcrumbs: (on: boolean) => void;
}

export const useFieldStore = create<FieldState>()(
  persist(
    (set, get) => ({
      isFieldMode: false,
      drawerState: 'closed',
      drawerTab: 'damage',
      quickCreateMode: null,
      drawingMode: null,
      autoTrackBreadcrumbs: false,

      setFieldMode: (on) => set({ isFieldMode: on }),
      setDrawerState: (state) => set({ drawerState: state }),
      setDrawerTab: (tab) => set({ drawerTab: tab }),
      toggleDrawer: () => {
        const current = get().drawerState;
        set({ drawerState: current === 'closed' ? 'half' : 'closed' });
      },
      setQuickCreateMode: (mode) => set({ quickCreateMode: mode }),
      setDrawingMode: (mode) => set({ drawingMode: mode, drawerState: mode ? 'closed' : get().drawerState }),
      setAutoTrackBreadcrumbs: (on) => set({ autoTrackBreadcrumbs: on }),
    }),
    {
      name: 'field-ops-storage',
      partialize: (state) => ({
        isFieldMode: state.isFieldMode,
        drawerState: state.drawerState,
        drawerTab: state.drawerTab,
        autoTrackBreadcrumbs: state.autoTrackBreadcrumbs,
      }),
    }
  )
);
